import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import ReactionChip from "../../atoms/ReactionChip";
import EmojiPicker from "../EmojiPicker";

import "./index.scss";

export default function MessageReactions({
    reactions,
    onToggleReaction,
    canReact,
    className = "",
}) {
    if (!Array.isArray(reactions) || reactions.length === 0) {
        return null;
    }

    const handleToggle = (emoji, reacted) => {
        if (!emoji || typeof onToggleReaction !== "function") {
            return;
        }
        onToggleReaction(emoji, reacted);
    };

    const handleAddReaction = (emoji) => {
        const native = typeof emoji === "string" ? emoji : emoji?.native;
        if (!native) {
            return;
        }
        // Add (never remove) via the same toggle API
        handleToggle(native, false);
    };

    return (
        <div className={classNames("message-reactions", className)}>
            {reactions.map((reaction) => (
                <ReactionChip
                    key={reaction.emoji}
                    emoji={reaction.emoji}
                    count={reaction.count}
                    active={Boolean(reaction.reacted)}
                    disabled={!canReact}
                    onToggle={() => handleToggle(reaction.emoji, Boolean(reaction.reacted))}
                />
            ))}
            {canReact && (
                <div className="message-reactions__add">
                    <EmojiPicker onSelectEmoji={handleAddReaction} iconAlt="Add reaction" />
                </div>
            )}
        </div>
    );
}

MessageReactions.propTypes = {
    reactions: PropTypes.arrayOf(PropTypes.shape({
        emoji: PropTypes.string.isRequired,
        count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        reacted: PropTypes.bool,
    })),
    onToggleReaction: PropTypes.func,
    canReact: PropTypes.bool,
    className: PropTypes.string,
};

MessageReactions.defaultProps = {
    reactions: [],
    onToggleReaction: undefined,
    canReact: true,
    className: "",
};
